// src/pages/FeaturedProjects/FeaturedProjects.jsx

import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PropertyCard from '../../../../components/Buyer/propertycards/PropertyCard';

import { FaSliders } from 'react-icons/fa6';
import '../../../../assets/css/Buyer/Home/featureProperty/featureproperty.css';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import AppContext from 'context/AppContext';
import axios from 'axios';

const FeatureProperty = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [properties, setProperties] = useState([]);
  const {baseUrl,baseUrlForFiles,authToken} =useContext(AppContext);

  const [filteredCount] = useState(479); // Total properties count


  const getLatestProperties = () => {
    axios
      .get(`${baseUrl}/buyer/home/latestProperties`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        console.log(response.data);
        setProperties(response.data.property);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getLatestProperties();
  }, []);


  // Filter toggle handler
  const toggleFilter = () => {
    setIsFilterOpen(prev => !prev);
  };

  return (
    <section className="home-featured-projects-section">
      <Container>

        {/* Row 2 */}
        <div className="home-featured-header-row-2">
          <h1 className="home-featured-title">Featured Properties</h1>
          <div className="home-featured-right-group">

            <div className="home-property-count-box">
              <span className="home-count-number">{filteredCount}</span>
              <span className="home-count-label">offers</span>
            </div>
          </div>
        </div>

        {/* Property Cards Grid - 2x2 Layout */}
        <Row className="home-property-cards-grid g-4">
          {properties.map((property) => (
            <Col key={property.id} xs={12} md={6} lg={6}>
              <PropertyCard property={property} baseUrlForFiles={baseUrlForFiles} />
            </Col>
          ))}
        </Row>
      </Container>



    </section>
  );
};

export default FeatureProperty;